// extracted by mini-css-extract-plugin
export default {"iconShutterstock":"IconShutterstock_iconShutterstock__izoAu"};